// Public claims reflect Maycie's experience. Keep internal implementation details private.
export const projects = [
  {
    id: 'consolidation', number: '01', category: 'Storefront consolidation',
    title: 'Website Consolidation',
    name: 'Stickley Website Consolidation',
    description: 'I handled the front-end implementation to consolidate Stickley’s brand and retail websites into one Shopify Plus storefront, working with marketing and other departments.',
    tags: ['Shopify Plus', 'Front-end development', 'Storefront architecture'],
    overview: 'Stickley was retiring a separate brand website. The retail storefront needed to bring that content and functionality into a single, cohesive destination.',
    contribution: 'I rebuilt the retail website to incorporate the retiring site’s brand content and functionality. This involved storefront architecture, interface implementation, and collaboration with marketing and other departments.',
    scope: ['Front-end implementation on Shopify Plus', 'Brand content and functionality integration', 'Storefront structure and cross-department collaboration'],
    url: 'https://www.stickley.com/', linkText: 'Visit Stickley',
  },
  {
    id: 'collectors', number: '02', category: 'Collection launch',
    title: 'Collector’s Shop Launch',
    name: 'Stickley Collector’s Shop',
    description: 'I helped launch a collection of accessories, decorative pieces, and collectibles, handling product setup, storefront implementation, and ongoing technical support.',
    tags: ['Shopify merchandising', 'Product launches', 'Collections'],
    overview: 'The Collector’s Shop is a collection within Stickley’s Shopify storefront, featuring smaller accessories, decorative products, and collectible items.',
    contribution: 'I helped launch the collection through product setup, collection implementation, and storefront development. My role also includes ongoing technical support as the collection evolves.',
    scope: ['Product setup and collection launch', 'Storefront implementation and e-commerce functionality', 'Ongoing technical support'],
    url: 'https://www.stickley.com/collections/collectors-shop', linkText: 'Explore the collection',
  },
  {
    id: 'integrations', number: '03', category: 'Integrations & automation',
    title: 'Integrations & Automation',
    name: 'Stickley Integrations & Automation',
    description: 'I configure integrations and workflow automations, implement analytics and consent management, and troubleshoot issues across connected e-commerce systems.',
    tags: ['Shopify Flow', 'Klaviyo', 'Analytics & consent'],
    overview: 'This work supports Stickley’s day-to-day e-commerce operations through application integrations, workflow automation, and analytics.',
    contribution: 'My responsibilities include Shopify Flow automations, Klaviyo and third-party app integrations, Shopify Customer Events, analytics implementation, and consent management. I also troubleshoot e-commerce functionality and work with existing order-management and ERP integrations.',
    scope: ['Workflow automation and app configuration', 'Customer events, analytics, and consent implementation', 'Technical troubleshooting across connected systems'],
  },
  {
    id: 'storefront', number: '04', category: 'Ongoing development',
    title: 'Ongoing Front-End Development',
    name: 'Stickley Front-End Development',
    description: 'Ongoing improvements to product pages, responsive layouts, and custom storefront features, alongside application compatibility and technical troubleshooting.',
    tags: ['Front-end development', 'Liquid & metafields', 'Responsive UX'],
    overview: 'As Stickley’s sole front-end developer, I maintain and extend the storefront as business needs change.',
    contribution: 'My work includes custom Liquid development, product page enhancements, dynamic content and metafields, and custom storefront functionality. I also improve responsive layouts and troubleshoot application compatibility and user experience issues.',
    scope: ['Custom themes, Liquid, and dynamic content', 'Product page and responsive layout improvements', 'Application compatibility and technical troubleshooting'],
  },
];

export const expertise = [
  {
    number: '01', title: 'Front-End Development',
    skills: ['HTML5 & CSS3', 'JavaScript', 'React', 'Responsive development', 'Interface implementation', 'Custom functionality', 'UI troubleshooting'],
  },
  {
    number: '02', title: 'E-Commerce & Shopify',
    skills: ['Shopify Plus & Flow', 'Liquid & custom theme development', 'Metafields & theme architecture', 'Products & collections', 'Shopify app integrations', 'E-commerce UX', 'Shopify Customer Events'],
  },
  {
    number: '03', title: 'Integrations & Analytics',
    skills: ['Klaviyo', 'Google Analytics 4', 'Microsoft Clarity', 'Consent management', 'Analytics implementation', 'Third-party app configuration & integrations'],
  },
  {
    number: '04', title: 'Development Tools & Workflows',
    skills: ['Git & GitHub', 'AI-assisted development', 'Agentic coding', 'AI-assisted debugging & code review', 'Technical problem-solving', 'Workflow optimization'],
  },
];
